export default __webpack_public_path__ + "static/media/oh2.47c7d21f.png";